// File: client/src/platform/variantRegistry.js
//
// The variant registry: a Map from variant id -> normalised variant module. The
// app discovers available game modes ONLY through this registry (no hardcoded mode
// lists, no if/else on ids). Registering a module is the sole step to add a variant.

import { normalizeVariant } from './variantContract';
import { validateRulebook } from './rulebookContract';

const registry = new Map();

/**
 * Register a variant module. Validates and normalises it (throws on a malformed
 * module so mistakes surface at startup, not mid-game). Idempotent per id: a repeat
 * registration replaces the prior one (useful for tests / hot reload).
 * @param {object} mod a variant module (see variantContract)
 */
export function registerVariant(mod) {
  const normalized = normalizeVariant(mod);
  validateRulebook(normalized.rulebook, normalized.id);
  registry.set(normalized.id, normalized);
}

/** Get a variant module by id, or undefined if not registered. */
export function getVariant(id) {
  return registry.get(id);
}

/** True if a variant id is registered. */
export function hasVariant(id) {
  return registry.has(id);
}

/**
 * List all registered variants, sorted by their `order` then name. Returns the
 * normalised modules; the menu renders straight from this.
 */
export function listVariants() {
  return Array.from(registry.values()).sort(
    (a, b) => a.order - b.order || a.name.localeCompare(b.name)
  );
}

/** Test helper: clear the registry. */
export function __resetRegistry() {
  registry.clear();
}
